import {notNull} from '../../../../../../../library/clxProductNet/assets/js/modules/common/assert';

export default class MetaNavigation {
    private readonly toTop: HTMLDivElement;
    private readonly navTop: HTMLDivElement | null = null;
    private readonly scrollThreshold = 102;

    constructor() {
        this.toTop = notNull(document.querySelector<HTMLDivElement>('#footer .to_top')); // xxx move to footer related class
        this.navTop = document.querySelector<HTMLDivElement>('#header .top');

        this._initScrollListener();
        this._attachCShopLinkEvent();
    }

    private _initScrollListener(): void {
        document.addEventListener('scroll', () => {
            const scrollY = window.scrollY;

            if (scrollY > this.scrollThreshold) {
                document.body.classList.add('scroll');
                this.toTop.style.setProperty('display', 'block');
                if (this.navTop) {
                    this.navTop.setAttribute('inert', '');
                }
            } else {
                document.body.classList.remove('scroll');
                this.toTop.style.setProperty('display', 'none');
                if (this.navTop) {
                    this.navTop.removeAttribute('inert');
                }
            }
        });

        this.toTop.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        });
    }

    private _attachCShopLinkEvent(): void {
        const cShopLink: HTMLLinkElement | null = document.querySelector('#header .top .cshop > a');

        cShopLink?.addEventListener('click', () => {
            try {
                // @ts-ignore
                _paq.push(['trackEvent', 'Endkundenshop öffnen', 'Link in MetaNavigation']);
            } catch (e) {
                if (e instanceof ReferenceError) {
                    // Handle error as necessary
                }
            }
        });
    }
}
